import cn from 'classnames'
import qs from 'qs'
import React, { useEffect, useState } from 'react'
import { Tab } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import ContentTabs from '../contenttabs/ContentTabs'
import { setQueryStringWithoutPageReloadPush } from '../helpers/FormatLinks'
import LoadingIndicator from '../loadingindicator'
import SearchComponent from '../searchitems/SearchComponent'
import TabItem from '../tabitem/TabItem'
import { UserControlPanel } from './UserControlPanel'
import { UserImage } from './UserImage'
import { useSharedState } from '../waxplorer/Waxplorer'

export const UserComponent = (props) => {
    const { t } = useTranslation('common')
    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null
    const user = props['user']

    const [initial, setInitial] = useState(true)
    const [lastTab, setLastTab] = useState(null)

    let values = qs.parse(
        window.location.search.substring(1, window.location.search.length),
    )

    const getTabKey = (key) => {
        return [
            'inventory',
            'listings',
            'buyoffers',
            'sells',
            'buys',
            'auctions',
            'transfers',
            'history',
        ].includes(key)
            ? key
            : 'inventory'
    }

    const tab =
        typeof window !== 'undefined'
            ? values['tab']
                ? values['tab']
                : props.tab
                ? props.tab
                : ''
            : ''

    const view =
        typeof window !== 'undefined'
            ? values['view']
                ? values['view']
                : 'overview'
            : props.tab
            ? props.tab
            : ''

    const [tabKey, setTabKey] = useState(
        getTabKey(typeof window !== 'undefined' && tab ? tab : 'inventory'),
    )

    useEffect(() => {
        if (lastTab !== tabKey && !initial) {
            const query = []
            if (tabKey !== 'default') {
                query['tab'] = tabKey
            }

            if (query['offer_type']) {
                delete query['offer_type']
            }

            setQueryStringWithoutPageReloadPush(qs.stringify(query))
        }

        setLastTab(tabKey)

        setInitial(false)
    }, [tabKey])

    useEffect(() => {
        if (
            view !== 'wallet' &&
            [
                'inventory',
                'friends',
                'listings',
                'buyoffers',
                'sells',
                'buys',
                'auctions',
                'transfers',
                'history',
            ].includes(tab)
        ) {
            location.hash = '#Tabs'
        }
    }, [tab])

    const myProfile = user === userName

    const tabCount = 9

    return !user ? (
        <LoadingIndicator />
    ) : (
        <div className={'w-full px-2 lg:px-4'}>
            <div
                className={cn(
                    'relative flex flex-wrap w-full h-auto my-auto mt-4',
                )}
                id={'TopContainer'}
            >
                <div className="w-full lg:w-1/3">
                    <UserImage user={user} />
                </div>
                <div className="w-full lg:w-2/3 pt-4 lg:pt-0 pl-0 lg:pl-4">
                    <UserControlPanel user={user} tab={view} />
                </div>
            </div>
            <div
                className={cn(
                    'w-full h-full border dark:!bg-paper bg-white border-zinc-200 dark:!border-paperl shadow-xl rounded-md mt-4',
                )}
            >
                <ContentTabs
                    bg={''}
                    tabKey={tabKey}
                    onSelect={(k) => setTabKey(k)}
                    id={'Tabs'}
                >
                    <Tab
                        eventKey="inventory"
                        title={
                            <TabItem
                                tabCount={tabCount}
                                target={'inventory'}
                                tabKey={tabKey}
                                title={t('profile.inventory')}
                                size={'small'}
                            />
                        }
                    >
                        {tabKey === 'inventory' && user ? (
                            <SearchComponent
                                {...props}
                                searchSettings={{
                                    owner: { value: user, fixed: true },
                                    search_type: {
                                        value: 'inventory',
                                        fixed: false,
                                    },
                                    order_by: {
                                        value: 'transferred_desc',
                                        fixed: false,
                                    },
                                    minimal: false,
                                    tab: 'inventory',
                                    page_component: false,
                                    limit: { value: 60, fixed: true },
                                    expanded: false,
                                }}
                                limit={60}
                                tab={tabKey}
                            />
                        ) : null}
                    </Tab>

                    <Tab
                        eventKey="listings"
                        title={
                            <TabItem
                                tabCount={tabCount}
                                target={'listings'}
                                tabKey={tabKey}
                                title={t('search.sales')}
                                size={'small'}
                            />
                        }
                    >
                        {tabKey === 'listings' && user ? (
                            <SearchComponent
                                searchSettings={{
                                    owner: { value: user, fixed: true },
                                    search_type: {
                                        value: 'listings',
                                        fixed: true,
                                    },
                                    order_by: {
                                        value: 'date_desc',
                                        fixed: false,
                                    },
                                    minimal: false,
                                    tab: 'listings',
                                    page_component: false,
                                    limit: { value: 60, fixed: true },
                                    expanded: false,
                                }}
                                limit={60}
                                tab={tabKey}
                            />
                        ) : null}
                    </Tab>
                    <Tab
                        eventKey="buyoffers"
                        title={
                            <TabItem
                                tabCount={tabCount}
                                target={'buyoffers'}
                                tabKey={tabKey}
                                title={t('navigation.buy_offers')}
                                size={'small'}
                            />
                        }
                    >
                        {tabKey === 'buyoffers' && user ? (
                            <SearchComponent
                                searchSettings={{
                                    owner: { value: user, fixed: true },
                                    search_type: {
                                        value: myProfile
                                            ? 'my_buyoffers'
                                            : 'buyoffers',
                                        fixed: true,
                                    },
                                    order_by: {
                                        value: 'date_desc',
                                        fixed: false,
                                    },
                                    minimal: false,
                                    tab: 'buyoffers',
                                    page_component: false,
                                    limit: { value: 60, fixed: true },
                                    expanded: false,
                                }}
                                limit={36}
                                tab={tabKey}
                            />
                        ) : null}
                    </Tab>
                    <Tab
                        eventKey="auctions"
                        title={
                            <TabItem
                                tabCount={tabCount}
                                target={'auctions'}
                                tabKey={tabKey}
                                title={t('search.auctions')}
                                size={'small'}
                            />
                        }
                    >
                        {tabKey === 'auctions' && user ? (
                            <SearchComponent
                                searchSettings={{
                                    owner: { value: user, fixed: true },
                                    search_type: {
                                        value: myProfile
                                            ? 'my_auctions'
                                            : 'auctions',
                                        fixed: false,
                                    },
                                    order_by: {
                                        value: 'end_asc',
                                        fixed: false,
                                    },
                                    minimal: false,
                                    tab: 'auctions',
                                    searchOfferType: 'auctions',
                                    page_component: false,
                                    limit: { value: 60, fixed: true },
                                    expanded: false,
                                }}
                                limit={60}
                                tab={tabKey}
                            />
                        ) : null}
                    </Tab>
                    <Tab
                        eventKey="buys"
                        title={
                            <TabItem
                                tabCount={tabCount}
                                target={'buys'}
                                tabKey={tabKey}
                                title={t('overview.purchases')}
                                size={'small'}
                            />
                        }
                    >
                        {tabKey === 'buys' && user ? (
                            <SearchComponent
                                searchSettings={{
                                    owner: { value: user, fixed: true },
                                    search_type: { value: 'buys', fixed: true },
                                    order_by: {
                                        value: 'date_desc',
                                        fixed: false,
                                    },
                                    minimal: false,
                                    page_component: false,
                                    limit: { value: 60, fixed: true },
                                    tab: 'buys',
                                    expanded: false,
                                }}
                                limit={60}
                            />
                        ) : null}
                    </Tab>
                    <Tab
                        eventKey="sells"
                        title={
                            <TabItem
                                tabCount={tabCount}
                                target={'sells'}
                                tabKey={tabKey}
                                title={t('overview.sells')}
                                size={'small'}
                            />
                        }
                    >
                        {tabKey === 'sells' && user ? (
                            <SearchComponent
                                searchSettings={{
                                    owner: { value: user, fixed: true },
                                    search_type: {
                                        value: 'sells',
                                        fixed: true,
                                    },
                                    order_by: {
                                        value: 'date_desc',
                                        fixed: false,
                                    },
                                    minimal: false,
                                    page_component: false,
                                    limit: { value: 60, fixed: true },
                                    tab: 'sells',
                                    expanded: false,
                                }}
                                limit={60}
                            />
                        ) : null}
                    </Tab>
                    <Tab
                        eventKey="transfers"
                        title={
                            <TabItem
                                tabCount={tabCount}
                                target={'transfers'}
                                tabKey={tabKey}
                                title={t('asset.transfers')}
                                size={'small'}
                            />
                        }
                    >
                        {tabKey === 'transfers' && user ? (
                            <SearchComponent
                                searchSettings={{
                                    owner: { value: user, fixed: true },
                                    search_type: {
                                        value: 'transfers',
                                        fixed: true,
                                    },
                                    order_by: {
                                        value: 'date_desc',
                                        fixed: false,
                                    },
                                    minimal: false,
                                    page_component: false,
                                    limit: { value: 60, fixed: true },
                                    tab: 'transfers',
                                    expanded: false,
                                }}
                                limit={60}
                            />
                        ) : null}
                    </Tab>
                </ContentTabs>
            </div>
        </div>
    )
}

export default UserComponent
